import { Component, OnInit, ChangeDetectionStrategy, OnDestroy, Input } from '@angular/core';
import { UploaddocumentService } from '../services/uploaddocument/uploaddocument.service';
import { ToastrService } from 'ngx-toastr';
import { LoggerService } from '../services/logger/logger.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { NotifyUserComponent } from '../notify-user/notify-user.component';
import { RegistrationModel } from 'src/app/registrations-data/models/data/registration.model';
import { Document } from 'src/app/models/document.model';
import { NewRegistrationDataCollectionService } from '../services/registration/newRegistration-data-collection.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-ir-uploaded-document',
    templateUrl: './ir-uploaded-documents.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class IRUploadedDocumentComponent implements OnInit, OnDestroy {

    @Input() isEditable;
    @Input() documentTypes;
    @Input() sectionName;
    // @Input() reason: Array<string> = [];
    transactionGuid: string;
    registration: RegistrationModel;

    subscription: Subscription;

    registrationSubject: BehaviorSubject<RegistrationModel> = new BehaviorSubject<RegistrationModel>(null);
    registrationForm$: Observable<RegistrationModel> = this.registrationSubject.asObservable();

    constructor(
        private dialog: MatDialog,
        private toastrService: ToastrService,
        private uploaddocumentService: UploaddocumentService,  private activatedRoute: ActivatedRoute,
        private dataCollectionSvc: NewRegistrationDataCollectionService
    ) {
    }

    ngOnInit() {
        this.subscription = this.dataCollectionSvc.selectedTransactionGUID$.subscribe(transactionGuid => {
            this.transactionGuid = transactionGuid;
        });
        this.dataCollectionSvc.regFormObserv.subscribe(registration => {
            if (registration) {
                this.registration = registration;
                const matchedAttachment = [];
                registration.documents.forEach(attachment => {
                    // if (this.reason.indexOf(attachment.type) < 0) {
                    // if (attachment.type === 'HPDWorkBook' && this.reason.indexOf('Section421a16') < 0) {
                    // if (registration.building.info.reason.indexOf(attachment.type) < 0) {
                    const reasons = registration.registrationSummary.reasons || [];
                    if (registration.registrationSummary && attachment.documentType &&
                        reasons.filter(x => x.code === attachment.documentType.code).length < 0) {
                        if (attachment.documentType.code === 'HPDWorkBook'
                            && registration.registrationSummary && registration.registrationSummary.reasons.filter
                                (x => x.code === 'Section421a16').length < 0) {

                            this.uploaddocumentService.delete(attachment.documentId);
                            this.notifyUser(attachment);
                        } else if (attachment.documentType.code === 'RegulatoryAgreement') {
                            this.uploaddocumentService.delete(attachment.documentId);
                            this.notifyUser(attachment);
                        } else {
                            matchedAttachment.push(attachment);
                        }
                    } else {
                        matchedAttachment.push(attachment);
                    }
                });
                registration.documents = matchedAttachment;
                this.registrationSubject.next(registration);
            }
        });
    }

    notifyUser(attachment: Document) {
        const message = `The attached document to ${attachment.documentType.description} is deleted`;
        this.dialog.open(
            NotifyUserComponent, {
            data: message
        }
        ).afterClosed().subscribe((result) => {
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    deleteDocument(data) {
        this.openConfirmationDialogDeleteDocument(data);
    }

    onViewClick(data) {
        this.uploaddocumentService.viewDocument(this.activatedRoute.snapshot.params.registrationId, data.documentId)
        .subscribe(response => {
            const blob = new Blob([response], { type: response.type });
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank');
        }, errors => {
            this.toastrService.error('Viewing Document failed', 'File retrieval failed');
        });
    }

    // added filter options not to show any other Approved documents;
    filterAttachments(documents) {
        if (!documents || documents.length === 0) {
            return documents;
        } else {
            const docs = [];
            /* this.documentTypes.forEach(doc => {
                const docm = documents.find(val => val.type === doc.code);
                if (docm) {
                    docs.push(docm);
                }
            });
            documents = docs; */
            documents.forEach(val => {
                if (val.sectionName === this.sectionName) {
                    docs.push(val);
                }
            });
            documents = docs;
        }
        return documents/* .filter (doc => doc.type === 'RegulatoryAgreement' || doc.type === 'HPDWorkBook' || doc.type === 'Other'
        || doc.type === 'GovernmentDirective' || doc.type === 'HcrOrder' || doc.type === 'CoverLetter'); */
            ;
    }

    // open dialog confirmation if they want to revise when there are other IN-PROGRESS Registrations.
  openConfirmationDialogDeleteDocument(data) {
    const confirmationDialogRef = this.dialog.open(
      ConfirmationDialogComponent,
      {
        width: '900px',
        data: 'Are sure you want to delete this document?'
      }
    );
    confirmationDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.uploaddocumentService.deleteDocument(this.activatedRoute.snapshot.params.registrationId, data.documentId)
        .subscribe(response => {
            this.toastrService.success('Document Deleted successfully', 'Delete Success');
            this.registration.documents = this.registration.documents.filter(attachment => {
                return attachment.documentId !== data.documentId;
            });
            this.dataCollectionSvc.sync(this.registration, this.activatedRoute.snapshot.params.registrationId);
        }, errors => {
            this.toastrService.error('Document Deletion failed! Please try again.', 'Delete failed');
        });
      }
    });
  }
}
